var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",on:{"click":_vm.onClick}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('h1',{staticClass:"level-name"},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }